// /mnt/mantenimientos/frontend/src/modules/helpers.js

export function sortModules(modules = []) {
  return [...modules].sort((a, b) => {
    const aOrder = Number.isFinite(Number(a.order)) ? Number(a.order) : 9999;
    const bOrder = Number.isFinite(Number(b.order)) ? Number(b.order) : 9999;
    return aOrder - bOrder;
  });
}

export function canAccessModule(module, role) {
  if (!module || !role) return false;
  if (!Array.isArray(module.roles)) return false;
  return module.roles.includes(role);
}

export function getAvailableModules(registry = [], role) {
  return sortModules((registry || []).filter((m) => canAccessModule(m, role)));
}

export function getModuleById(registry = [], moduleId) {
  return (registry || []).find((m) => m.id === moduleId) || null;
}

export function getModulesBySection(registry = [], role) {
  const available = getAvailableModules(registry, role);

  return {
    global: available.filter((m) => m.section === "global"),
    cliente: available.filter((m) => m.section === "cliente"),
  };
}
